var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_781_602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 16.75C14.4404 16.75 15 16.1904 15 15.5C15 14.8096 14.4404 14.25 13.75 14.25C13.0596 14.25 12.5 14.8096 12.5 15.5C12.5 16.1904 13.0596 16.75 13.75 16.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6106 15.1741C18.2243 14.1903 17.5579 13.3415 16.6939 12.7329C15.83 12.1242 14.8064 11.7825 13.75 11.75C12.6936 11.7825 11.67 12.1242 10.8061 12.7329C9.94206 13.3415 9.27566 14.1903 8.88944 15.1741L8.75 15.5L8.88944 15.8259C9.27566 16.8097 9.94206 17.6585 10.8061 18.2671C11.67 18.8758 12.6936 19.2175 13.75 19.25C14.8064 19.2175 15.83 18.8758 16.6939 18.2671C17.5579 17.6585 18.2243 16.8097 18.6106 15.8259L18.75 15.5L18.6106 15.1741ZM13.75 18C13.2555 18 12.7722 17.8534 12.3611 17.5787C11.95 17.304 11.6295 16.9135 11.4403 16.4567C11.2511 15.9999 11.2016 15.4972 11.298 15.0123C11.3945 14.5273 11.6326 14.0819 11.9822 13.7322C12.3319 13.3826 12.7773 13.1445 13.2623 13.048C13.7472 12.9516 14.2499 13.0011 14.7067 13.1903C15.1635 13.3795 15.554 13.7 15.8287 14.1111C16.1034 14.5222 16.25 15.0055 16.25 15.5C16.2493 16.1628 15.9856 16.7983 15.5169 17.2669C15.0483 17.7356 14.4128 17.9993 13.75 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.0002H5V3.00022H10V6.75022C10.001 7.08144 10.133 7.39883 10.3672 7.63304C10.6014 7.86726 10.9188 7.99926 11.25 8.00022H15V10.5002H16.25V6.75022C16.2522 6.66807 16.2366 6.58642 16.2043 6.51089C16.1719 6.43536 16.1235 6.36775 16.0625 6.31272L11.6875 1.93771C11.6325 1.87667 11.5649 1.82829 11.4893 1.79592C11.4138 1.76355 11.3321 1.74795 11.25 1.75021H5C4.66877 1.75117 4.35139 1.88317 4.11717 2.11739C3.88296 2.3516 3.75096 2.66899 3.75 3.00022V18.0002C3.75096 18.3314 3.88296 18.6488 4.11717 18.883C4.35139 19.1173 4.66877 19.2493 5 19.2502H7.5V18.0002ZM11.25 3.25022L14.75 6.75022H11.25V3.25022Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.7b8d72741af7bb7a53e51d2a546dbdf3.svg";
export { ForwardRef as ReactComponent };